import {useMutation} from "@tanstack/react-query";

import {deleteClientMutationOptions} from "./delete-client.mutation-options";

export function useDeleteClient() {
  return useMutation(deleteClientMutationOptions());
}
